import * as React from "react";
import { PensionType } from "../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IStepConfig, StepType } from "../../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../../Resoures/Contents";
import { Urls } from "../../../../Urls";
import { NewQuoteAction } from "../Actions/NewQuoteAction";
import { quoteSteppersMap } from "../Resource/Content";
import { QuoteClientInfoStore, QuoteInstructionStore } from "../Store/Variable";
import { QuoteReady } from "./QuoteReady/QuoteReady";
import { AdviserCharges } from "./SIPP/AdviserCharges/AdviserCharges";
import { AdviserCharges as AdviserChargesIsa } from "./ISA/AdviserCharges/AdviserCharges";
import { AdviserCharges as AdviserChargesPp } from "./PP/AdviserCharges/AdviserCharges";
import { DrawdownDetails } from "./SIPP/DrawdownDetails/DrawdownDetails";
import { IncomePaymentDetails } from "./SIPP/IncomePaymentDetails/IncomePaymentDetails";
import { InvestmentSelectionTool as ISTQuoteSIPP } from "./SIPP/IST/InvestmentSelectionTool";
import { InvestmentSelectionTool as ISTQuotePP } from "./PP/IST/InvestmentSelectionTool";
import { InvestmentSelectionTool as ISTQuoteISA } from "./ISA/IST/InvestmentSelectionTool";
import { PaymentsIn } from "./SIPP/PaymentsIn/PaymentsIn";
import { PaymentsIn as PaymentInIsa } from "./ISA/PaymentsIn/PaymentsIn";
import { PaymentsIn as PaymentInPp } from "./PP/PaymentsIn/PaymentsIn";
import { WrapperSelection } from "./WrapperSelection/WrapperSelection";
import { WizardComponent } from "../../../../../Shared/Process/WizardComponent";
import { Withdrawals } from "../../Common/Withdrawals/Withdrawals";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import {
    hasCashTransfer,
    hasRegularPayments,
    hasSinglePayments,
} from "../../../../../Shared/IST/Components/Shared/Utils";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { showIncome } from "../../Common/PaymentsIn/SIPP/ValidationHelper";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { Action } from "../../../../Actions/Action";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { DrawdownCalculationStoreStore } from "../../Common/SIPP/DrawdownDetails/Store/Variable";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Methods } from "../../../../Common/CommonHelper";
import { Transition } from "../../../../../Shared/Process/Process/Transition";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { AccountAdviceType } from "../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../../Common/Documents/Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { QuoteModel } from "../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ClientNameHelper } from "../../Common/Helpers/ClientNameHelper";
import { ChargesHelper } from "../../Common/Helpers/ChargesHelper";

export class NewQuoteWizard extends WizardComponent {
    constructor(props: any) {
        super(props);

        this.subscribeToStore(QuoteClientInfoStore, () => this.onQuoteClientDetailStoreChange());
        this.subscribeToStore(QuoteInstructionStore, () => this.onQuoteInstructionStoreChange());
        this.subscribeToStore(DrawdownCalculationStoreStore, () => this.onPostDrawdown());
    }

    private onQuoteInstructionStoreChange() {
        const data = QuoteInstructionStore.getData();
        this.setState({
            isLoading: false,
            data: data,
            onPosting: false,
            active: data.Status === InstructionStatus.Pending || data.Status === InstructionStatus.NotSpecified,
        });
    }

    private onPostDrawdown() {
        if (DrawdownCalculationStoreStore.getActionType() == ActionType.Loading) {
            this.setState({ onPosting: true });
        }
    }

    private onQuoteClientDetailStoreChange() {
        const data = QuoteClientInfoStore.getData();
        this.setState({ clientInfo: data });
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];

        this.setState({
            data: {
                SelectedProducts: [],
                AllBankAccounts: [],
                BankAccountInstructions: [],
                GiaQuote: {},
                ISAQuote: {},
                PensionQuote: {},
                QuoteReference: {},
                AnnuityAssumptions: { PensionIncreases: 0 },
                ExistingAccountHierarchyId: hierarchyId,
                ActivityType: CommonHelper.isNullOrEmpty(hierarchyId)
                    ? ActivityType.Quote
                    : ActivityType.NewQuoteExistingClient,
            },
        });
        const id = getQueryParameters()["id"];
        if (id) {
            NewQuoteAction.getQuoteInstruction(id);
        } else {
            this.setState({ isLoading: false });
        }

        if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            if (this.state.clientAccount) {
                this.updateClientAccountInfo(this.state.clientAccount);
            } else {
                Action.getClientAccount(hierarchyId, (val) => {
                    this.updateClientAccountInfo(val);
                });
            }
        }
    }

    updateClientAccountInfo(val: ClientAccount): void {
        const { PensionQuote } = this.state.data;

        PensionQuote.ExistingPensionSubAccountHierarchyId = val?.SubAccounts?.find(
            (x) => x.SubAccountType == SubAccountType.Npr
        )?.HierarchyId;
        this.onChange({
            PensionQuote: PensionQuote,
            ExistingAccountHierarchyId: val?.HierarchyId,
            IsExistingAccount: true,
            AdviceGiven: true,
            AccountAdviceType: val?.Discretionary
                ? AccountAdviceType.Discretionary
                : AccountAdviceType.NonDiscretionary,
            AccountName: { Full: val.AccountName },
        });
        if (val != null) {this.setState({ clientAccount: val });}
    }
    onSubmit() {}

    saveInstruction(from, to, toUrl, params, stepLength) {
        const customerId = params["customerid"];
        const instructionId = params["id"];
        this.state.data.CustomerId = parseInt(customerId);
        if (to < stepLength - 1) {
            NewQuoteAction.saveQuoteInstruction(from, this.state.data, (result) => {
                this.setState({ onPosting: false });
                if (result.length > 0) {
                    this.setState({ errorMsg: result, isShowErrorMsg: true });
                } else {
                    if (to == -1) {
                        this.onExit();
                    } else {
                        Navigator.navigateTo(toUrl, {
                            queryParamsObject: {
                                ...params,
                                customerid: customerId,
                                id: QuoteInstructionStore.getData()?.AccountRoleInstructionId,
                            },
                            scrollAfterNavigating: true,
                        });
                    }
                }
            });
        } else {
            NewQuoteAction.saveQuoteInstruction(from, this.state.data, () => {
                NewQuoteAction.submitQuoteInstruction(instructionId, () => {
                    this.setState({ onPosting: false, active: false });
                    if (to == -1) {
                        this.onExit();
                    } else {
                        Navigator.navigateTo(toUrl, {
                            queryParamsObject: {
                                ...params,
                                customerid: customerId,
                                id: QuoteInstructionStore.getData()?.AccountRoleInstructionId,
                            },
                            scrollAfterNavigating: true,
                        });
                    }
                });
            });
        }
    }

    onCancel() {
        // NewQuoteAction.deleteQuoteInstruction(QuoteInstructionStore.getData()?.AccountRoleInstructionId, () =>
        //     this.onExit()
        // );
        //SLP-70599
        this.onExit();
    }

    onExit() {
        Navigator.navigateTo(
            Urls.get().main.PortfolioDashboard({
                hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                    HierarchyLevelName.Customer,
                    getQueryParameters()["customerid"]
                ),
            }).activity
        );
    }

    getStepProps(index) {
        const { data, active } = this.state;
        const stepProps = super.getStepProps(index);
        return stepProps;
    }

    private getPPStepConfig(): IStepConfig[] {
        const data = this.state.data;
        const len = this.stepperConfig.length;
        const pp = data?.SelectedProducts.find((item) => item.SubAccountType == SubAccountType.InvestmentAccount);
        const steps = [
            {
                title: quoteSteppersMap.paymentsIn,
                url: Urls.get().QuotePaymentsInPP,
                path: Contents.URLMap.paymentInPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <PaymentInPp {...this.getStepProps(len)} />,
                group: quoteSteppersMap.PP,
            },
            {
                title: quoteSteppersMap.adviserCharges,
                url: Urls.get().QuoteAdviserChargesPP,
                path: Contents.URLMap.adviserChargesPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <AdviserChargesPp {...this.getStepProps(len + 1)} />,
                group: quoteSteppersMap.PP,
            },
        ];
        let hasIST = false;
        if (hasSinglePayments(data.GiaQuote) || hasRegularPayments(data.GiaQuote)) {
            hasIST = true;
            steps.push({
                title: quoteSteppersMap.investment,
                url: Urls.get().QuoteInvestmentSelectionPP,
                path: Contents.URLMap.investmentSelectionPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <ISTQuotePP {...this.getStepProps(len + 2)} />,
                group: quoteSteppersMap.PP,
            });
        }
        if (
            pp?.IsAddRegularWithdrawalSelected &&
            (hasSinglePayments(data.GiaQuote) ||
                hasRegularPayments(data.GiaQuote) ||
                ChargesHelper.hasTransfers(data.GiaQuote, SubAccountType.InvestmentAccount))
        ) {
            const gap = hasIST ? 3 : 2;
            steps.push({
                title: quoteSteppersMap.withdrawal,
                url: Urls.get().QuoteWithdrawalsPP,
                path: Contents.URLMap.withdrawalsPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <Withdrawals {...this.getStepProps(len + gap)} modelName="GiaQuote" type={ProcessType.Quote} />
                ),
                group: quoteSteppersMap.PP,
            });
        }

        return steps;
    }
    private getISAStepConfig(next: SubAccountType): IStepConfig[] {
        const { data } = this.state;
        const len = this.stepperConfig.length;
        const isa = data.SelectedProducts.find((ele) => ele.SubAccountType == SubAccountType.StocksIsa);
        const steps: IStepConfig[] = [
            {
                title: quoteSteppersMap.paymentsIn,
                url: Urls.get().QuotePaymentsInISA,
                path: Contents.URLMap.paymentInISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <PaymentInIsa {...this.getStepProps(len)} />,
                group: quoteSteppersMap.ISA,
            },
            {
                title: quoteSteppersMap.adviserCharges,
                url: Urls.get().QuoteAdviserChargesISA,
                path: Contents.URLMap.adviserChargesISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <AdviserChargesIsa {...this.getStepProps(len + 1)} />,
                group: quoteSteppersMap.ISA,
            },
        ];
        let hasIST = false;
        if (
            hasSinglePayments(data.ISAQuote) ||
            hasRegularPayments(data.ISAQuote) ||
            hasCashTransfer(data.ISAQuote?.IsaTransfers)
        ) {
            hasIST = true;
            steps.push({
                title: quoteSteppersMap.investment,
                url: Urls.get().QuoteInvestmentSelectionISA,
                path: Contents.URLMap.investmentSelectionISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <ISTQuoteISA {...this.getStepProps(len + 2)} />,
                group: quoteSteppersMap.ISA,
            });
        }

        if (
            isa?.IsAddRegularWithdrawalSelected &&
            (hasSinglePayments(data.ISAQuote) ||
                hasRegularPayments(data.ISAQuote) ||
                ChargesHelper.hasTransfers(data.ISAQuote, SubAccountType.StocksIsa))
        ) {
            const gap = hasIST ? 3 : 2;
            steps.push({
                title: quoteSteppersMap.withdrawal,
                url: Urls.get().QuoteWithdrawalsISA,
                path: Contents.URLMap.withdrawalsISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <Withdrawals {...this.getStepProps(len + gap)} modelName="ISAQuote" />,
                group: quoteSteppersMap.ISA,
            });
        }

        if (next) {
            steps.push({
                title: "ISA complete",
                url: Urls.get().QuoteISAComplete,
                path: Contents.URLMap.completeISA,
                component: <Transition from={SubAccountType.StocksIsa} to={next} />,
                type: StepType.Extra,
            });
        }
        return steps;
    }

    private getSIPPStepConfig(next: SubAccountType): IStepConfig[] {
        const len = this.stepperConfig.length;
        let hasIST = 0;
        let hasDrawdown = 0;
        const data = this.state.data;
        const sipp = data?.SelectedProducts.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType));
        const steps: IStepConfig[] = [
            {
                title: quoteSteppersMap.paymentsIn,
                url: Urls.get().QuotePaymentsInSIPP,
                path: Contents.URLMap.paymentInSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <PaymentsIn
                        {...this.getStepProps(len)}
                        processType={
                            CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
                                ? ProcessType.NB
                                : ProcessType.NBEC
                        }
                        HasExistingSIPP={
                            this.state.clientAccount?.SubAccounts?.find(
                                (x) =>
                                    x.SubAccountType == SubAccountType.Pension ||
                                    x.SubAccountType == SubAccountType.Sipp ||
                                    x.SubAccountType == SubAccountType.Npr ||
                                    x.SubAccountType == SubAccountType.Pr
                            ) != undefined
                        }
                    />
                ),
                group: quoteSteppersMap.SIPP,
            },
            {
                title: quoteSteppersMap.adviserCharges,
                url: Urls.get().QuoteAdviserChargesSIPP,
                path: Contents.URLMap.adviserChargesSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <AdviserCharges {...this.getStepProps(len + 1)} />,
                group: quoteSteppersMap.SIPP,
            },
        ];
        if (
            hasSinglePayments(data.PensionQuote) ||
            hasRegularPayments(data.PensionQuote) ||
            hasCashTransfer(data.PensionQuote.PensionTransfers)
        ) {
            hasIST = 1;
            steps.push({
                title: quoteSteppersMap.investment,
                url: Urls.get().QuoteInvestmentSelectionSIPP,
                path: Contents.URLMap.investmentSelectionSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <ISTQuoteSIPP {...this.getStepProps(len + 2)} />,
                group: quoteSteppersMap.SIPP,
            });
        }
        if (sipp.PensionType !== PensionType.None) {
            hasDrawdown = 1;
            steps.push({
                title: quoteSteppersMap.drawdownDetails,
                url: Urls.get().QuoteDrawdownDetailSIPP,
                path: Contents.URLMap.drawdownDetailSipp,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <DrawdownDetails {...this.getStepProps(len + 2 + hasIST)} />,
                group: quoteSteppersMap.SIPP,
            });
        }
        if (showIncome(sipp, this.state.data?.PensionQuote)) {
            steps.push({
                title: quoteSteppersMap.incomePaymentDetails,
                url: Urls.get().QuoteIncomePaymentSIPP,
                path: Contents.URLMap.incomePaymentsSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <IncomePaymentDetails {...this.getStepProps(len + 2 + hasDrawdown + hasIST)} />,
                group: quoteSteppersMap.SIPP,
            });
        }
        if (next) {
            steps.push({
                title: "SIPP complete",
                url: Urls.get().QuoteSIPPComplete,
                path: Contents.URLMap.completeSIPP,
                component: <Transition from={SubAccountType.Npr} to={next} />,
                type: StepType.Extra,
            });
        }
        return steps;
    }

    setStepperConfig() {
        this.stepperConfig = [
            {
                title: quoteSteppersMap.wrapperSelection,
                url: Urls.get().QuoteWrapperSelection,
                path: Contents.URLMap.wrapperSelection,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <WrapperSelection
                        {...this.getStepProps(0)}
                        HasExistingSIPP={
                            this.state.clientAccount?.SubAccounts?.find(
                                (x) =>
                                    x.SubAccountType == SubAccountType.Pension ||
                                    x.SubAccountType == SubAccountType.Sipp ||
                                    x.SubAccountType == SubAccountType.Npr ||
                                    x.SubAccountType == SubAccountType.Pr
                            ) != undefined
                        }
                        ClientAccount={this.state.clientAccount}
                    />
                ),
            },
        ];
        const hasPension = this.state.data.SelectedProducts.some((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const hasIsa = this.state.data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.StocksIsa);
        const hasPP = this.state.data.SelectedProducts.some(
            (ele) => ele.SubAccountType == SubAccountType.InvestmentAccount
        );
        if (hasPension) {
            const next = hasIsa ? SubAccountType.StocksIsa : hasPP ? SubAccountType.InvestmentAccount : null;
            this.stepperConfig = this.stepperConfig.concat(this.getSIPPStepConfig(next));
        }

        if (hasIsa) {
            const next = hasPP ? SubAccountType.InvestmentAccount : null;
            this.stepperConfig = this.stepperConfig.concat(this.getISAStepConfig(next));
        }

        if (hasPP) {
            this.stepperConfig = this.stepperConfig.concat(this.getPPStepConfig());
        }

        this.stepperConfig.push({
            title: quoteSteppersMap.quoteReady,
            url: Urls.get().QuoteReady,
            path: Contents.URLMap.quoteReady,
            type: StepType.Custom,
            onStepLeave: (from, to) => {
                this.onStepperLeave(from, to);
            },
            component: <QuoteReady {...this.getStepProps(this.stepperConfig.length)} />,
        });
    }

    onSave(step) {
        const id = getQueryParameters()["id"];
        if (id) {
            this.onStepperLeave(step, -1);
        } else {
            this.setState({ extraInfo: { isSaving: true, currentStep: step } });
        }
    }

    saveAndExit() {
        const step = this.state.extraInfo.currentStep;
        // wrapper selection
        if (step == 0) {
            this.onExit();
        }
    }

    customeRender() {
        const { extraInfo } = this.state;
        return (
            <>
                {extraInfo.isSaving && (
                    <Lightbox
                        show={extraInfo.isSaving}
                        title={"Do you want to save and exit?"}
                        unclosable={true}
                        onClose={() => this.onChange({ extraInfor: { isSaving: false } })}
                        cssWrapper="is-default-lightbox is-narrow"
                        contentCssCustom="pt-20"
                    >
                        <p className="mb-10">
                            No data will be saved at this point, you will not be able to resume this wizard.
                        </p>
                        <p>Are you sure you want to save and exit?</p>

                        <button className="btn primary mr-20 mt-20" onClick={() => this.saveAndExit()}>
                            Yes
                        </button>
                        <button
                            className="btn secondary  mt-20"
                            onClick={() => this.setState({ extraInfo: { isSaving: false } })}
                        >
                            No
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }

    getAccountHolderDisplayText() {
        const model: QuoteModel = this.state.data;
        return ClientNameHelper.clientNameDisplay(model?.ClientDetails, model?.SecondClientDetails);
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "New quote";
        processProps.subTitle = Methods.getProductNameFromUrl();
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: this.getAccountHolderDisplayText(),
            splitHeaderSub: "",
        };
        processProps.onSave = (step) => this.onSave(step);
        return processProps;
    }
}
